/** Debajo funciones standalone */
// https://gist.github.com/nmsdvid/8807205
export function debounce(a,b,c){var d;return function(){var e=this,f=arguments;clearTimeout(d),d=setTimeout(function(){d=null,c||a.apply(e,f)},b),c&&!d&&a.apply(e,f)}}

export function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
}

export function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

export function eraseCookie(name) {   
    document.cookie = name+'=; Max-Age=-99999999;path=/;';  
}

export function injectScript(src, type) {

    window._injectedScripts = window._injectedScripts || [];
    
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        if (type) {
            script.type = type;
        }
        script.addEventListener('load', (e) => {
            window._injectedScripts.push(src);
            resolve(e);
        });
        script.addEventListener('error', e => reject(e.error));
        document.body.appendChild(script);
    });
}

export function injectScriptOnce(src, type) {
    window._injectedScripts = window._injectedScripts || [];

    if (window._injectedScripts.indexOf(src) > -1) {
        return new Promise((resolve, reject) => {
            resolve();
        });
    }
    
    return injectScript(src, type);
}

export function linearConversion(OldValue, OldMin, OldMax, NewMin, NewMax) {
    return (((OldValue - OldMin) * (NewMax - NewMin)) / (OldMax - OldMin)) + NewMin;
}

export function awaitTimeout(delay) {
    return new Promise(resolve => setTimeout(resolve, delay));
}

export function getWindowScrollTop() {
    var doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
}

export function getWindowWidth() {
    return window.innerWidth;
}

export function setCss(elements, styles, value = null) {

    if (typeof styles === 'string' && value !== null) {
        styles = {
            [styles]: value
        };
    }

    if (elements instanceof Element) {
        elements = [elements];
    } else if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    elements.forEach(element => {
        for (let property in styles) {
            element.style[property] = styles[property];
        }
    });
}

export function initAllModules(rootElement = document, moduleNames = null, args = {}) {
    let kdModules = [];
    rootElement.querySelectorAll('*[kd-module]').forEach(elm => {
        if (elm.hasAttribute('kd-initted')) {
            return;
        }
        kdModules.push(initSingleModule(elm, moduleNames, args));
    });

    return kdModules;
}

export function initSingleModule(elm, moduleNames = null, args = {}) {
    
    moduleNames = moduleNames || elm.getAttribute('kd-module');

    if (typeof moduleNames === 'function') {
        moduleNames = [moduleNames];
    } else {
        moduleNames = moduleNames.split(',').map(moduleName => moduleName.trim());
    }

    moduleNames.forEach(moduleName => {
        let moduleFn;
        if (typeof moduleName === 'function') {
            moduleFn = moduleName;
        } else {
            moduleFn = window.modules[moduleName] || window[moduleName];
        }

        if (typeof moduleFn !== 'function') {
            throw new Error(`Module ${moduleName} not found.`);
        }
        let module = new moduleFn(elm, args);
        elm.kdModule = module;
    });
    
    elm.setAttribute('kd-initted', true);
    elm.dispatchEvent(new CustomEvent('kdinit'));
   
    return elm.kdModule;
}

window.initSingleModule = initSingleModule;


export function equalizeHeightByOffset(selector, options) {

	options = Object.assign({
        property: 'minHeight',
        margin: 0,
    }, options);

	var heightByOffsetTop = {};

    let thoseElements = document.querySelectorAll(selector);

	function equalize() {
        setCss(thoseElements, {
            [options.property]: ''
        });

        thoseElements.forEach(element => {
            let offsetTop = element.getBoundingClientRect().top;
            let height 	  = element.getBoundingClientRect().height;

            if (options.property === 'minHeight') {
                heightByOffsetTop[offsetTop] = heightByOffsetTop[offsetTop] || 0;
                heightByOffsetTop[offsetTop] = Math.max(heightByOffsetTop[offsetTop], height);
            } else { // min
                heightByOffsetTop[offsetTop] = heightByOffsetTop[offsetTop] || Number.MAX_SAFE_INTEGER;
                heightByOffsetTop[offsetTop] = Math.min(heightByOffsetTop[offsetTop], height);
            }
        });

		for (let offsetTop in heightByOffsetTop) {
			var height = heightByOffsetTop[offsetTop];

            let filtered = []
            thoseElements.forEach(element => {
                let diff = Math.abs(parseInt(element.getBoundingClientRect().top, 10) - parseInt(offsetTop, 10));

                if (diff <= options.margin) {
                    filtered.push(element);
                }
            });

            filtered.forEach(element => {
                setCss(element, {
                    [options.property]: height + 'px'
                });
            });
	
		}
	}

    window.addEventListener('resize', debounce(equalize, 100));
    setTimeout(equalize, 10);

};

export function money(amount, decimals = 2) {
    let value = (amount).toLocaleString(
        'es-ES',   // leave undefined to use the visitor's browser 
                   // locale or a string like 'en-US' to override it.
        { 
            minimumFractionDigits: decimals,
            useGrouping: 'auto',
            currency: 'EUR',
            currencyDisplay: 'symbol',
            style: 'currency'
        }
    );

    return value;
}

export function unmoney(amount) {
    return amount.replace('€', '').replace('.', '').trim();
}

export function between(x, min, max) {
    return x >= min && x <= max;
}

window.hideVeil = function() {
    let veil = document.querySelector('.loadveil');
    if (veil) {
        let anim = veil.animate(
            { opacity: [1,0] }, 
            { 
                duration: 1000, 
                fill: 'forwards',
            }
        );
        anim.onfinish = function() {
            veil.style.display = 'none';
        }
    }
}

window.showVeil = function() {
    let veil = document.querySelector('.loadveil');
    if (veil) {
        veil.style.display = 'block';
        veil.animate(
            { opacity: [0,1] }, 
            { 
                duration: 100, 
                fill: 'forwards',
            }
        );
    }
}

export function changeSelectOptions(select, options) {

    if (typeof select === 'string') {
        select = document.querySelector(select);
    }
    
    let currentValue = select.value;
    
    select.innerHTML = '';

    options.forEach(option => {
        let optionElm = document.createElement('option');
        optionElm.value = option.value;
        optionElm.innerHTML = option.label;

        if (option.value === currentValue) {
            optionElm.selected = true;
        }
        select.appendChild(optionElm);
    });

}

export function filter(array, callback) {
    let filtered = [];
    array.forEach(item => {
        if (callback && callback(item)) {
            filtered.push(item);
        } else if (item) {
            filtered.push(item);
        }
    });
    return filtered;
}

export function getTodayYmd() {
    return (new Date).toISOString().split('T')[0];
}

export function getTodayDmy() {
    return formatDate(new Date);
}

export function formatDate(date) {
    return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/**
 * 
 * @since 2024-04-30 defaultOptionValue can also be an select attribute (data-empty-option-label)
 */
export function fillSelect(select, options, defaultOptionLabel = null) {

    if (typeof select === 'string') {
        select = document.querySelector(select);
    }

    defaultOptionLabel = defaultOptionLabel || select.dataset.emptyOptionLabel || window.TEXTS.SELECT;
    
    let currentValue = select.value;
    
    select.innerHTML = '<option value="">' + defaultOptionLabel + '</option>';

    options.forEach(option => {
        let optionElm = document.createElement('option');

        optionElm.value = option.value;
        optionElm.innerHTML = option.label;

        if (option.disabled) {
            optionElm.disabled = true;
        }

        if (option.value === currentValue) {
            optionElm.selected = true;
        }

        if (option.dataset) {
            Object.assign(optionElm.dataset, option.dataset);
        }

        select.appendChild(optionElm);
    });

}

export function getUniqueItems(arrayItems) {
	return [...new Set(arrayItems)];
}

export function ymdToDmy(date) {
	let parts = date.split('-');
	return parts[2] + '/' + parts[1] + '/' + parts[0];
}

export function dmyToYmd(date) {
	let parts = date.split('/');
	return parts[2] + '-' + parts[1] + '-' + parts[0];
}

/**
 * @since 2024-05-06 first param containers could be an array
 */
export function setLoading(containers, loading) {

    if (!Array.isArray(containers)) {
        containers = [containers];
    }

    containers.forEach(container => {
        let isStatic = window.getComputedStyle(container).position === 'static';

        if (loading) {
            if (isStatic) {
                container.style.position = 'relative';
            }
            container.classList.add('is-loading');
            
        } else {
            container.classList.remove('is-loading');
        }
    });
}

export function swalAlert(title, text = null) {

    document.body.classList.add('prevent-scroll');

    let parts = splitAlertTitleText(title);

    text = parts.text || text;

    return Swal.fire({
        title: parts.title,
        html: text,
        showConfirmButton: false,
        // confirmButtonText: 'Ok',
        buttonsStyling: false,
        showCloseButton: true,
        customClass: {
            // confirmButton: 'button1',
            // popup: 'text-center',
        }
    }).then((result) => {
        document.body.classList.remove('prevent-scroll');
        return result;
    });
}

export function splitAlertTitleText(text) {
    if (text.match('/\|\|\|/')) {
        let parts = text.split('|||');
        return {
            title: parts[0],
            text: parts[1],
        }
    }
    return {
        title: text,
        text: null,
    }
}

export function onDelegatedClick(parent, selector, callback, useCapture) {
    return onDelegatedEvent('click', parent, selector, callback, useCapture);
}

export function onDelegatedEvent(eventName, parent, selector, callback, useCapture) {
    return parent.addEventListener(eventName, function(e) {

        let selectorTarget = e.target.closest(selector);

        if (!selectorTarget) {
            return;
        }

        e.selectorTarget = selectorTarget;

        callback(e);
        
    }, useCapture);
}

export function onClick(element, callback) {
    return element.addEventListener('click', function(e) {
        callback(e);
    });
}

export function parseElementAsJson(element) {
    return JSON.parse(element.innerText);
}

export function changeCase(textCase, text) {

    if (textCase === 'title') {
        text = text.replace(/\w\S*/g, function(txt){
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });

        text = text.replace(/_/, ' ');

        return text;
    }

    throw new Error('Unknown text case: ' + textCase);

}


export function objectToFormData(obj) {
    let formData = new FormData();

    for (let key in obj) {
        formData.append(key, obj[key]);
    }

    return formData;
}

export function formElementToObject(form) {
    let formData = new FormData(form);
    return formDataToObject(formData);
}

export function formDataToObject(formData) {

    let data = {};

    for (let key of formData.keys()) {
        data[key] = formData.get(key);
    }

    return data;
}

/**
 * 
 * @since 2024-03-26 Added sl-switch
 * @returns 
 */
export function genericElementToFormData(el) {
    const formData = new FormData();
    const inputs = el.querySelectorAll('input, textarea, select, sl-switch, button');
    
    inputs.forEach(input => {

        if (input.disabled) {
            return;
        }
        
        if (input.type === 'checkbox' || input.type === 'radio' || input.tagName === 'SL-SWITCH') {
            if (input.checked) { 
                formData.append(input.name, input.value); 
            }
        } else if (input.tagName === 'SELECT' && input.multiple) {
            [...input.options].forEach(option => {
                if (option.selected) formData.append(input.name, option.value);
            });
        } else if (input.tagName === 'INPUT' && input.type === 'file') {
            if (input.files.length) {
                formData.append(input.name, input.files[0]);
            }
        } else {
            formData.append(input.name, input.value);
        }
    });
    
    return formData;
}

export function setSelectValue(select, value) {
    value = value.toString();
    select.value = value;

    // Si no se establece es porque no hay un option, lo añadimos
    if (select.value !== value) {
        let optionElm = document.createElement('option');
        optionElm.value = value;
        optionElm.innerHTML = value;
        optionElm.selected = true;
        select.appendChild(optionElm);
    }
}
export function addParamsToUrl(url, params) {
    let urlObj = new URL(url, window.location.origin);

    for (let key in params) {
        urlObj.searchParams.delete(key);
        urlObj.searchParams.append(key, params[key]);
    }
    return urlObj.toString();
}

/**
 * @since 2024-05-06 Added X-Toastify
 */
export function processStandardBackendHeaders(response, scopeElement = null) {

    // Dispatch Event
        let eventName = response.headers.get('X-Dispatch-Event');
        if (eventName) {
            scopeElement.dispatchEvent(new CustomEvent(eventName, { bubbles: true, }));
        }

    // Flash message
        let flashMessage = response.headers.get('X-Flash-Message');
        if (flashMessage) {
            if (typeof swalAlert === 'function') {
                swalAlert(flashMessage)
            } else {
                alert(flashMessage);
            }
        }

        let toastifyMessage = response.headers.get('X-Toastify');
        if (toastifyMessage && typeof Toastify !== 'undefined') {
            let background = response.headers.get('X-Toastify-Background') || 'green';
            Toastify({ 
                text: toastifyMessage, 
                duration: 3000,
                style: {
                    background: background,
                    color: 'white'
                }
            }).showToast();
        }

    // Redirect
        let redirect = response.headers.get('X-Location');

        if (redirect) {
            location.href = redirect;
        }

    return response;

}


export function fixCakephpSortLinks() {
		
    const urlParams = new URLSearchParams(window.location.search);

    if (!urlParams.has('direction')) {
        return;
    }

    var nextDirection = urlParams.get('direction') == 'asc' ? 'desc' : 'asc';
    var regex = /direction=(asc|desc)/;

    let anchors = document.querySelectorAll('table th a');

    anchors.forEach(anchor => {
        let href = anchor.getAttribute('href');
        if (href.match(regex)) {
            href = href.replace(regex, 'direction=' + nextDirection);
            anchor.setAttribute('href', href);
        }
    });

}

/**
 * Reemplaza el contenido de un elemento identificado por un id por el de el mismo dentro del HTML pasado como parámetro.
 * @param DOMElement target 
 * @param string sourceHtml 
 * @param object options 
 *      - callback: function
 *      - executeScripts: boolean
 * 
 * @since 2024-03-15 If the target element is not found in the source html, the function will console log the response
 * @since 2024-10-04 Added options
 */
export function replacePageContent(target, sourceHtml, options = {}) {

    let callback = options.callback || null;
    let executeScripts = options.executeScripts || false;

    let domId = target.getAttribute('id');

    let html;
    let tmpDiv = document.createElement('div');
    tmpDiv.innerHTML = sourceHtml;
    let sourceElement = tmpDiv.querySelector('#' + domId);

    if (!sourceElement) {
        console.warn('Element with id ' + domId + ' not found in source html.');
        console.log(sourceHtml);
        return;
    }
    
    html = sourceElement.innerHTML;

    viewTransition(() => {
        target.scrollTop = 0;

        if (executeScripts) {
            setInnerHTMLWithScript(target, html);
        } else {
            target.innerHTML = html;
        }
        // target.style.display = '';
        initAllModules(target);

        callback && callback();
        
    });
}

export function viewTransition(callback) {
    if (document.startViewTransition) {
        document.startViewTransition(() => {
            callback();
        });
    } else {
        callback();
    }
}

export function tryJsonParse(str) {
    try {
        return JSON.parse(str);
    } catch(e) {
        return null;
    }
}

export function getUrlParam(url, paramName) {
    let urlObj = new URL(url);
    return urlObj.searchParams.get(paramName);
}

export function animate(element, properties, duration = 400, easing = 'linear') {
    // Convert the properties object to an array of keyframes
    const keyframes = [
        {}, // Starting state (current computed values)
        properties // End state (provided values)
    ];

    // Create animation options
    const options = {
        duration: duration,
        easing: easing,
        fill: 'forwards' // Ensure the animation's effects remain after it finishes
    };

    // Use the animate method on the element
    element.animate(keyframes, options);
}

export function hasVerticalScrollBar(element) {
    return element.clientHeight < element.scrollHeight;
}

export function hasHorizontalScrollBar(element) {
   return element.clientWidth < element.scrollWidth;
} 

export function getSelectValues(select) {
    let result = [];
    let options = select && select.options;
    let opt;
  
    for (let i = 0, iLen = options.length; i < iLen; i++) {
        opt = options[i];

        if (opt.selected) {
            result.push(opt.value || opt.text);
        }
    }
    return result;
}

export function isTextSelected() {
    var selection = window.getSelection();
    return selection && selection.type === 'Range';
}

export function animateAttribute(element, attributeName, from, to, duration = 400) {
    let cancel = false;  // Flag to determine if the animation should be cancelled

    // Capture the start time
    const startTime = performance.now();

    // Helper function to update the attribute
    function update() {
        if (cancel) {
            return;  // Stop the animation if cancelled
        }

        // Calculate the current time elapsed
        const timeElapsed = performance.now() - startTime;
        // Calculate the progress ratio
        const progress = Math.min(timeElapsed / duration, 1);
        
        // Calculate the current attribute value
        const currentValue = from + (to - from) * progress;
        
        // Update the attribute
        element.setAttribute(attributeName, currentValue);
        
        // Continue the animation until the end
        if (progress < 1) {
            requestAnimationFrame(update);
        }
    }

    // Start the animation
    requestAnimationFrame(update);

    // Return a function that can be called to cancel the animation
    return function cancelAnimation() {
        cancel = true;
    };
}

export function escapeHtml(value) {
    return String(value)
        .replace(/&/g, '&amp;') 
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')  
        .replace(/>/g, '&gt;'); 
}

export function objectToHtmlAttributes(obj) {
    let str = Object.entries(obj)
        .map(([key, value]) => `${key}="${escapeHtml(value)}"`)
        .join(' ');                                            

    return str;
}

export function html(strings, ...values) {
    let str = '';
    strings.forEach((string, i) => {
        str += string + (values[i] || '');
    });
    return str;
}

export function css(strings, ...values) {
    let str = '';
    strings.forEach((string, i) => {
        str += string + (values[i] || '');
    });
    return str;
}

// https://stackoverflow.com/a/47614491
export function setInnerHTMLWithScript(elm, html) {
    elm.innerHTML = html;

    Array.from(elm.querySelectorAll('script')).forEach( oldScriptEl => {
        const newScriptEl = document.createElement('script');
        
        Array.from(oldScriptEl.attributes).forEach( attr => {
            newScriptEl.setAttribute(attr.name, attr.value) 
        });
        
        const scriptText = document.createTextNode(oldScriptEl.innerHTML);
        newScriptEl.appendChild(scriptText);
        
        oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
    });
}

/**
 * @since 2024-05-08 Added allow-scripts to sl-include
 */
export function createDrawerWithUrl(url, label, options = {}) {

    url = url.replace('{{t}}', Date.now());
    
    let drawer = document.createElement('sl-drawer');
    drawer.label = label;
    drawer.innerHTML = html`
        <sl-include src="${url}" allow-scripts>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
        </sl-include>
    `;

    if (options.class) {
        drawer.classList.add(options.class);
    }

    document.body.appendChild(drawer);

    customElements.whenDefined('sl-drawer').then(() => {
        drawer.show();
    });

    drawer.addEventListener('sl-after-hide', event => {
        if (event.target === drawer) {
            drawer.remove();
        }
    });

    return drawer;
}

/**
 * @since 2024-05-08 Added allow-scripts to sl-include
 */
export function createDialogWithUrl(url, label, options = {}) {

    url = url.replace('{{t}}', Date.now());
    
    let dialog = document.createElement('sl-dialog');
    dialog.label = label;
    dialog.innerHTML = html`
        <sl-include src="${url}" allow-scripts>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
        </sl-include>
    `;

    if (options.class) {
        dialog.classList.add(options.class);
    }

    document.body.appendChild(dialog);

    customElements.whenDefined('sl-dialog').then(() => {
        dialog.show();
    });

    dialog.addEventListener('sl-after-hide', event => {
        if (event.target === dialog) {
            dialog.remove();
        }
    });

    return dialog;
}


export function ymdFormat(date) {
    if (Object.prototype.toString.call(date) === '[object Date]') {
        return date.getFullYear() + '-' + ('0' + (date.getMonth()+1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    }

    var dateArray = date.split('/');
    return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
}

export function show(element) {
    element.style.display = '';
}

export function hide(element) {
    element.style.display = 'none';
}

export function isCursorAtEnd(inputElement) {
    return inputElement.selectionStart === inputElement.value.length;
}

export function isCursorAtStart(inputElement) {
    return inputElement.selectionStart === 0;
}

export function isCursorAtTextareaFirstLine(textareaElement) {
    var cursorPos = textareaElement.selectionStart;
    var firstLineBreakPos = textareaElement.value.indexOf('\n');
    return cursorPos <= firstLineBreakPos || firstLineBreakPos === -1;
}

export function isCursorAtTextareaLastLine(textareaElement) {
    var cursorPos = textareaElement.selectionStart;
    var lastLineBreakPos = textareaElement.value.lastIndexOf('\n');
    return lastLineBreakPos === -1 || (cursorPos > lastLineBreakPos && cursorPos === textareaElement.value.length);
}

/**
 * @since 2024-05-08 Uses replacePageContent
 * @since 2024-06-03 Option to set headers and body data
 */
export function ajaxUpdatePagePart(selector, url, options) {

    url = url || window.location.href;

    let request;
    let headers = {
        'X-Is-Ajax': '1'
    }

    if (options && options.headers) {
        headers = Object.assign(headers, options.headers);
    }

    if (options && options.method === 'POST') {
        let data = options.body || genericElementToFormData(document.querySelector(selector));
        request = new Request(url, {
            headers: headers,
            method: 'POST',
            body: data,
        });
    } else {
        request = new Request(url, {
            headers: headers,
        });
    }

    let replaceTarget = document.querySelector(selector);
    
    setLoading(replaceTarget, true);

    fetch(request)
        .then(res => {
            return res.text();
        })
        .then(res => {
            setLoading(replaceTarget, false);

            replacePageContent(replaceTarget, res, () => {
                // replaceTarget.scrollIntoView({
                //     behavior: 'smooth',
                //     block: 'start',
                // });
            });

        }).catch(err => {
            setLoading(replaceTarget, false);
            console.error(err);
        });

}


export function getDistance(lat1, lon1, lat2, lon2, unit) {
	if ((lat1 == lat2) && (lon1 == lon2)) {
		return 0;
	}
	else {
		var radlat1 = Math.PI * lat1/180;
		var radlat2 = Math.PI * lat2/180;
		var theta = lon1-lon2;
		var radtheta = Math.PI * theta/180;
		var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
		if (dist > 1) {
			dist = 1;
		}
		dist = Math.acos(dist);
		dist = dist * 180/Math.PI;
		dist = dist * 60 * 1.1515;
		if (unit=='K') { dist = dist * 1.609344 }
		if (unit=='N') { dist = dist * 0.8684 }
		return dist;
	}
}

export function markSearchedValue(content, searchValueArray) {
    // If no content or search terms, return original content
    if (!content || searchValueArray.length === 0) {
        return content;
    }

    // Normalize the original content once for searching
    const normalizedContent = removeSpecialChars(content).toLowerCase();
    let rangesToMark = []; // Store start/end indices from normalizedContent

    // Find all ranges in the normalized content that match any normalized search part
    searchValueArray.forEach((part) => {
        const normalizedPart = removeSpecialChars(part).toLowerCase();
        // Skip empty search parts
        if (normalizedPart.length === 0) return;

        let startIndex = 0;
        let index;
        // Find all occurrences of the normalized part within the normalized content
        while ((index = normalizedContent.indexOf(normalizedPart, startIndex)) > -1) {
            rangesToMark.push({ start: index, end: index + normalizedPart.length });
            // Move start index forward to find overlapping/subsequent matches correctly
            startIndex = index + 1; 
        }
    });

    // If no ranges were found, return original content
    if (rangesToMark.length === 0) {
        return content;
    }

    // Sort ranges by start index to handle merging correctly
    rangesToMark.sort((a, b) => a.start - b.start);

    // Merge overlapping or adjacent ranges
    let mergedRanges = [];
    if (rangesToMark.length > 0) {
        mergedRanges.push({...rangesToMark[0]}); // Start with the first range
        for (let i = 1; i < rangesToMark.length; i++) {
            let lastMerged = mergedRanges[mergedRanges.length - 1];
            let current = rangesToMark[i];
            // If current range overlaps or touches the last merged range
            if (current.start < lastMerged.end) { 
                // Extend the end of the last merged range if necessary
                lastMerged.end = Math.max(lastMerged.end, current.end);
            } else {
                // Otherwise, add the current range as a new merged range
                mergedRanges.push({...current});
            }
        }
    }

    // Build the result string using the original content and merged ranges
    let result = '';
    let lastIndex = 0;
    mergedRanges.forEach(range => {
        // Append the substring from the original content before the current mark
        result += content.substring(lastIndex, range.start);
        // Append the marked substring from the original content
        result += `<mark>${content.substring(range.start, range.end)}</mark>`;
        // Update the index for the next substring
        lastIndex = range.end;
    });
    // Append any remaining part of the original content after the last mark
    result += content.substring(lastIndex);

    return result;
}

export function removeSpecialChars(str) {
    return str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function stringMatchesSearch(string, searchValueArray) {
    if (searchValueArray.length === 0) { 
        return true;
    }

    let normalizedString = removeSpecialChars(string).toLowerCase();
    return searchValueArray.every((part) => {
        return normalizedString.includes(removeSpecialChars(part).toLowerCase());
    });
}

export function tryGlobalDataOrJson(key) {
    window._globalData = window._globalData || {};
    if (key.startsWith('_globalData:')) {
        key = key.replace('_globalData:', '');
        return window._globalData[key] || null;
    }

    return tryJsonParse(key);
}

export function isPlainObject(obj) {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.getPrototypeOf(obj) === Object.prototype;
}
